"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormLabel = exports.labelPlacementOptions = void 0;
const react_1 = __importDefault(require("react"));
const FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
const styles_1 = require("@material-ui/core/styles");
const Color_1 = require("../styles/Color");
var labelPlacementOptions;
(function (labelPlacementOptions) {
    labelPlacementOptions["BOTTOM"] = "bottom";
    labelPlacementOptions["END"] = "end";
    labelPlacementOptions["START"] = "start";
    labelPlacementOptions["TOP"] = "top";
})(labelPlacementOptions = exports.labelPlacementOptions || (exports.labelPlacementOptions = {}));
exports.FormLabel = styles_1.withStyles({
    root: {
        color: Color_1.Color.GREY_DARK,
        letterSpacing: '0.24px',
        lineHeight: '24px',
    },
})((props) => react_1.default.createElement(FormControlLabel_1.default, Object.assign({ color: "default" }, props)));
exports.default = exports.FormLabel;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRm9ybUxhYmVsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2Zvcm1zL0Zvcm1MYWJlbC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsa0RBQTZDO0FBQzdDLDBGQUUwRTtBQUMxRSxxREFBZ0U7QUFDaEUsMkNBQXVEO0FBRXZELElBQVkscUJBS1g7QUFMRCxXQUFZLHFCQUFxQjtJQUM3QiwwQ0FBaUIsQ0FBQTtJQUNqQixvQ0FBYyxDQUFBO0lBQ2Qsd0NBQWdCLENBQUE7SUFDaEIsb0NBQWMsQ0FBQTtBQUNsQixDQUFDLEVBTFcscUJBQXFCLEdBQXJCLDZCQUFxQixLQUFyQiw2QkFBcUIsUUFLaEM7QUFFWSxRQUFBLFNBQVMsR0FBRyxtQkFBVSxDQUFDO0lBQ2hDLElBQUksRUFBRTtRQUNGLEtBQUssRUFBVSxhQUFLLENBQUMsU0FBUztRQUM5QixhQUFhLEVBQUUsUUFBUTtRQUN2QixVQUFVLEVBQUssTUFBTTtLQUN4QjtDQUNKLENBQUMsQ0FBRSxDQUFDLEtBQTRCLEVBQUUsRUFBRSxDQUFDLDhCQUFDLDBCQUFnQixrQkFBQyxLQUFLLEVBQUcsU0FBUyxJQUFLLEtBQUssRUFBSSxDQUFDLENBQUM7QUFFekYsa0JBQWUsaUJBQVMsQ0FBQyJ9